<template>
  <div id="app" v-loading="loading" @click="globalClickHandle">
    <!-- v-authid="['main_language']" -->
    <!-- inviteCode放在最外层， 放判断里面tg进来有问题 -->
    <inviteCode />
    <!-- 注册送金金额已到账里面不要写接口不然token 还没设置就弹出来了 -->
    <RegisterReward ref="registerRewardRef" class="registerRewardDialog" />
    <div v-if="(show === 0 || show === 1050052) && isAlive" id="appshow">
      <pop-dialog
        :show.sync="isPopBoxShow"
        :viwes="popViwes"
        :fullscreen="popFullscreen"
        :dataOpt.sync="getData"
      ></pop-dialog>
      <template v-if="!hasMaintain && show === 0">
        <!-- 救济金弹窗 -->
        <!-- <Reliefund /> -->
        <keep-alive :exclude="['otherGame', 'payGame', 'GameList', 'History', 'Collect', 'hNoticeCenter', 'LayoutBox']">
          <router-view></router-view>
        </keep-alive>
        <h-footer v-show="getIsMobile && showTab"></h-footer>
        <Charge :viwes="popViwes" :fullscreen="popFullscreen" :dataOpt.sync="getData" />
        <!-- 浮窗入口 -->
        <!-- <float-window-entry v-if="taken && defaultCoinCode"></float-window-entry> -->
        <float-window-entry></float-window-entry>
        <!-- 提现样式 -->
        <ExchangeStyle />
        <!-- 金币提现样式 -->
        <ExchangeFreeCoin />
        <loginOtherWallet />
        <searchDrawer />
        <!-- 登陆注册 -->
        <Login ref="LoginRef" />
        <!-- 领取红包 -->
        <redeemDialog ref="redeemDialogRef" :taskSuccess="taskSuccess" />
        <!-- 充值的金额已到账 -->
        <RankReward ref="RankRewardRef" class="rankRewardDialog" />
        <!-- 首充/复充奖励的金额已到账 -->
        <RankReward ref="RankRewardRef1" class="rankRewardDialog1" />

        <!-- 奖励提示：免费次数、VIP转盘、转盘等 -->
        <RewardTips ref="RewardTipsRef" />
        <!-- 错误码code提示 -->
        <CodeTips ref="codeTipsRef" />
        <!-- 领奖限制提示 -->
        <rewardLimite ref="rewardLimiteRef" />
        <!-- 集卡活动 -->
        <collectCard ref="collectCardRef" />
        <!-- 冲榜活动 -->
        <multiRushBank ref="multiRushBankRef" />
        <!-- 定时红包60s倒计时 -->
        <redeemTimeCountdown ref="redeemTimeCountdownRef" />
        <!-- 定时红包60s倒计时 -->
        <mysteriousRewards ref="mysteriousRewardsRef" />
        <!-- 客服组件 -->
        <CustomerService ref="CustomerService"></CustomerService>
        <!-- 拉新助力活动 -->
        <PopupDialog
          ref="pullNewActivityDialog"
          :width="$px2rem(600)"
          :dataOpt="{}"
          :class="[
            isStart === 1 || isStart === 2 ? 'home-activity-dialog mb-w100' : 'home-pull-new-dialog hidden-close',
            pullNewInfo.rewardStyle === 1 ? 'style2' : 'style1',
          ]"
          :top="isStart === 3 || isStart === 4 ? '25vh' : ''"
          :show.sync="showPullNewDialog"
          @close="closePullNewDialog"
        >
          <template #center>
            <div class="event-modal_box">
              <PullNewPower
                v-if="showPullNewDialog"
                :pullNewInfo="pullNewInfo"
                @close="closePullNewDialog"
                @changeStart="changePullNewDialog"
              />
            </div>
          </template>
        </PopupDialog>
        <!-- 充值成功安全提醒绑定手机 -->
        <popup-dialog
          class="bindPhone-wrap"
          ref="PopupDialog"
          :width="$px2rem(400)"
          :dataOpt="{ title: $t('Datalang.home_Security_Reminder') }"
          :top="'25vh'"
          :show.sync="bindPhoneDialogVisible"
          @close="bindPhoneDialogVisible = false"
        >
          <template #center>
            <div class="bindPhone-dialog">
              <div class="text-content">
                <img class="icon" :src="require(`@/assets/login/login_warning.png`)" alt="" srcset="" />
                <div class="text">
                  {{ $t("Datalang.home_For_the") }}
                </div>
              </div>
              <div class="bottom-wrap2">
                <div class="close" @click="bindPhoneConfirm">{{ $t("Datalang.Login_BTM_confirm") }}</div>
              </div>
            </div>
          </template>
        </popup-dialog>
        <!-- Instagram提示 -->
        <popup-dialog
          ref="PopupDialog"
          :width="$px2rem(400)"
          :dataOpt="{ title: $t('Datalang.home_Tips') }"
          :top="'25vh'"
          :show.sync="showInstagramTip"
          :lock-scroll="false"
          @close="showInstagramTip = false"
        >
          <template #center>
            <div class="bindPhone-dialog">
              <div class="text-content">
                <div class="text text1">{{ $t("Datalang.home_ins_scoll") }}👇</div>
              </div>
              <div class="bottom-wrap2">
                <div class="close" @click="showInstagramTip = false">{{ $t("Datalang.Login_BTM_confirm") }}</div>
              </div>
            </div>
          </template>
        </popup-dialog>
        <!-- h5限制弹窗 -->
        <DownloadDrawer
          :visible="showDownloadDrawer"
          :pwaIcon="h5DownloadDrawerInfo.pwaIcon"
          :systemCheck="h5DownloadDrawerInfo.systemCheck"
          type="h5RechargeLimit"
          @close="closeH5DownloadDrawer"
        />
        <!-- vip 升级公告 -->
        <PopupDialog
          ref="PopupDialog"
          :show.sync="showEventModal"
          :width="$px2rem(530)"
          class="vip-dialog"
          @close="closeVipTip"
        >
          <template #center>
            <div class="vip-container-dialog">
              <!-- <EventModal :list="vipTipList" :hiddenDot="true" @close="closeVipTip" /> -->
              <div class="vip-close" @click="closeVipTip">
                <i class="el-icon-close"></i>
              </div>
              <img class="vip-bg" :src="require('@/lobby_common/assets/vip/bg.webp')" alt />
              <div class="vip-level">{{ vipTipList.rankName || "" }}</div>
              <div class="vip-content">
                <!-- <div class="vip-title">{{ $t("Datalang.home_congratulation") }}</div> -->
                <div class="vip-tip">{{ vipTipList.languages.content || "" }}</div>
              </div>
              <div class="vip-btn" @click="handleToVip">
                <span class="btn-txt">{{ $t("Datalang.Login_BTM_confirm") }}</span>
                <img class="btn-img" :src="require('@/lobby_common/assets/vip/btn.webp')" alt />
              </div>
            </div>
          </template>
        </PopupDialog>
        <!-- 游戏奖励提示 -->
        <GameRewardTip ref="GameRewardTipRef" />
        <!-- 首充、复充引导 -->
        <ChargeGuide ref="ChargeGuideRef" />
        <!-- 首提引导 -->
        <FirstWithdrawGuide ref="FirstWithdrawGuideRef" />
        <!-- 定时红包引导 -->
        <RedeemTimeGuide ref="RedeemTimeGuideRef" />
        <!-- 游戏破产引导 -->
        <LuckySubsidy ref="LuckySubsidyRef" />
        <!-- 风险政策、风险偏好设置、风险提示 -->
        <RiskSetTip ref="RiskSetTipRef" />
        <!-- 游戏限制 -->
        <GameLimitDialog />
        <!-- 返回顶部 -->
        <BackTop v-if="getIsMobile" />
        <!-- 大奖注册充值引导 -->
        <GrandPrizeGuide ref="GrandPrizeGuideRef" />
        <!-- 公共充值  快速发起充值 -->
        <CommonCharge ref="commonChargeRef" @changeLoading="changeLoading" />
      </template>
    </div>
    <ErrorCmpt v-if="show === 1050053" :datashow="{ datashow: show, dataip: dataip }" />
    <!-- 全屏加载动画 -->
    <!-- {{ (show === 0, skeletonLoading) }} -->
    <div id="skeletonLoading_logo" v-if="(show === 0 || show === 1050052) && skeletonLoading">
      <img class="skeletonLoading" :src="'/logo.gif?v=' + version" alt="" />
    </div>
  </div>
</template>
<script>
import { getServiceDomain, getAdsEvents, getConf } from "@/lobby_common/api/resource_gen";
import { getResource, getPersonalCenterTemplate } from "@/lobby_common/cdnApi";
import { killPlayerUser } from "@/lobby_common/api/game_gen";
// import { dynamicCreateManifestDefault } from "@/lobby_common/utils/dynamicCreateManifest";

import { redRedeemCodeReceive } from "@/lobby_common/api/activity_gen.js";
import { getTokenByPromotion } from "@/lobby_common/api/user";
import { clickEvent, firebaseSave } from "@/lobby_common/api/user_gen.js";
import { getBankruptConfig } from "@/lobby_common/api/guess_gen.js";
import HFooter from "@/layout/header/h-footer.vue";
const floatWindowEntry = () => import("@/components/floatWindowEntry"); //  浮窗
const Charge = () => import("@/components/charge"); // 充值
const CommonCharge = () => import("@/components/charge/commonCharge.vue"); // 公共充值  快速发起充值
const ExchangeStyle = () => import("@/components/exchangeStyle/index.vue"); // 兑换
const ExchangeFreeCoin = () => import("@/components/exchangeFreeCoin/index.vue"); // 金币兑换
import CustomerService from "@/components/CustomerService/CustomerService";
const PopDialog = () => import("@/components/pop"); //  弹窗
const inviteCode = () => import("@/components/Login/modules/inviteCode.vue"); //  邀请码
const loginOtherWallet = () => import("@/lobby_common/mixins_components/loginOtherWallet/index.vue"); // 登录邀请
const PopupDialog = () => import("@/components/PopupDialog");
const PullNewPower = () => import("@/components/homePullNewPower/index.vue");
const DownloadDrawer = () => import("@/lobby_common/components/downloadDrawer/index.vue");
// const EventModal = () => import("@/components/eventsModal/index.vue");
// import PopupDialog from "@/components/PopupDialog";
// import PullNewPower from "@/components/homePullNewPower/index.vue";
// import Reliefund from "@/components/reliefund";
// import { intAdjustSDK, intFbSDK } from "@/lobby_common/utils/adjust.js";
import { intFbSDK } from "@/lobby_common/utils/adjust.js";
import { redirectUserPage, sendRouterConfigThis } from "@/lobby_common/utils/comVariables";
import { eventPost } from "@/lobby_common/utils/eventFunction";
import Exposure from "@/lobby_common/utils/exposure.js";
import grandPrizeTips from "@/lobby_common/utils/grandPrizeTips.js";
import {
  // formatTime,
  isGame,
  sendThis,
  saveDataToIndexedDB,
  // getDataFromIndexedDB,
  getDeviceInfo,
  getUrlkey,
  generateKey,
} from "@/lobby_common/utils/utils";
import { sendPopThis } from "@/lobby_common/utils/popConfig";
import { sendGameThis, payGameFun } from "@/lobby_common/utils/payGameFun";
import { sendPayGameThis } from "@/lobby_common/utils/payGame";
import { sendAuthThis, thirdLoginInit } from "@/lobby_common/utils/authLogin";
import { sendWsThis } from "@/lobby_common/utils/wsFun";
import wss from "@/lobby_common/utils/ws.js";
const ErrorCmpt = () => import("@/views/error/403.vue"); // 403
import { mapMutations } from "vuex";
import { getLocalStorage, removeLocalStorage, setLocalStorage } from "@/lobby_common/utils/auth";
import { sendUtilThis, debounce, cacheManage, setCacheData } from "@/lobby_common/utils/index";
import store from "@/lobby_common/store";
import { loginSuccess, eventsInit, adsEventsInit, sendBusThis } from "@/lobby_common/utils/busFunction.js";
import { mapGetters, mapActions } from "vuex";
import { setLocaleArr, setLocale, setPacketConfig } from "@/lobby_common/locale";
import { getAnyZoneTimeStamp } from "@/lobby_common/utils/date";
// import redeemDialog from "@/components/redeemDialog/index.vue"; // 领取成功组件
// import RankReward from "@/components/RankReward/index.vue"; // 打码排行榜推送组件
// import Fingerprint2 from "fingerprintjs2";
import searchDrawer from "@/components/searchDrawer/index.vue";
import { register } from "@/registerServiceWorker";
// import Login from "@/components/Login/index.vue";
const Login = () => import("@/components/Login/index.vue"); // 登录  注册
const RankReward = () => import("@/components/RankReward/index.vue"); // 奖励已到账
// const RegisterReward = () => import("@/components/RegisterReward/index.vue"); // 注册送金奖励已到账
import RegisterReward from "@/components/RegisterReward/index.vue"; // 注册送金奖励已到账
const RewardTips = () => import("@/components/RewardTips/index.vue"); // 奖励类型提示
const CodeTips = () => import("@/components/CodeTips/index.vue"); // 错误码弹窗提示组件
const rewardLimite = () => import("@/components/rewardLimite/index.vue"); // 错误码弹窗提示组件
// const redeemTimeCountdown = () => import("@/components/redeemTimeCountdown/index.vue"); // 定时红包60s倒计时
const redeemDialog = () => import("@/components/redeemDialog/index.vue"); // 领取成功组件
const collectCard = () => import("@/components/collectCard/index.vue"); // 集卡活动
const multiRushBank = () => import("@/components/multiRushBank/index.vue"); // 冲榜活动
const GameRewardTip = () => import("@/components/game/gameRewardTip.vue"); // 游戏奖励提示
const ChargeGuide = () => import("@/components/chargeGuide/index.vue"); // 首充、复充引导
const FirstWithdrawGuide = () => import("@/components/firstWithdrawGuide/index.vue"); // 首提引导
const RedeemTimeGuide = () => import("@/components/redeemTimeGuide/index.vue"); // 定时红包引导
const LuckySubsidy = () => import("@/components/luckySubsidy/index.vue"); // 破产 幸运补贴引导
const RiskSetTip = () => import("@/components/riskSetTip/index.vue");
const GameLimitDialog = () => import("@/components/payGame/gameLimitDialog.vue");
const redeemTimeCountdown = () => import("@/components/redeemTimeCountdown/index.vue");
const mysteriousRewards = () => import("@/components/mysteriousRewards/index.vue");
const BackTop = () => import("@/components/backTop/index.vue");
const GrandPrizeGuide = () => import("@/components/grandPrizeGuide/index.vue"); // 大奖注册充值引导
// import redeemTimeCountdown from "@/components/redeemTimeCountdown/index.vue"; // 定时红包60s倒计时
// import mysteriousRewards from "@/components/mysteriousRewards/index.vue"; // 神秘奖励
import TelegramUtil from "@/lobby_common/utils/telegramUtil.js";
import { clearAllDB } from "@/lobby_common/utils/jsonCache.js";

export default {
  mixins: [wss],
  name: "App",
  data() {
    return {
      version: window._custom_env_.version,
      skeletonLoading: false,
      // intAdjustSDK,
      redTimer: null,
      intFbSDK,
      userdata: {},
      user: {},
      showFlextimestamp: null,
      show: null,
      showTab: true,
      dataip: {},
      isAlive: true,
      hasMaintain: true,
      taskSuccess: {
        bonusAmount: 0,
        accuracy: 2,
        coinCode: undefined,
      },
      pullNewInfo: {}, // 拉新助力活动数据
      isStart: 1,
      showPullNewDialog: false,
      showDownloadDrawer: false,
      h5DownloadDrawerInfo: {},
      showEventModal: false,
      vipTipList: [],
      browserdata: {}, // 浏览器生成key
      firstScreenLoadTime: null,
      isShowTime: {},
      bindPhoneDialogVisible: false,
      commonChargeLoading: false,
      errormsg: [
        "Request failed with status code 401",
        "Network Error",
        "Script error.",
        "Request aborted",
        "Rejected",
        "timeout of 30000ms exceeded",
        "SyntaxError: Unexpected token",
        "Failed to fetch",
      ],
      getRedFun: undefined,
      showInstagramTip: false,
    };
  },
  taskTimer: null,
  components: {
    HFooter,
    Login,
    BackTop,
    redeemDialog,
    RankReward,
    RegisterReward,
    RewardTips,
    CodeTips,
    rewardLimite,
    collectCard,
    multiRushBank,
    redeemTimeCountdown,
    PopDialog,
    CustomerService,
    // CashEntrance,
    // Reliefund,
    ErrorCmpt,
    Charge,
    CommonCharge,
    ExchangeStyle,
    ExchangeFreeCoin,
    floatWindowEntry,
    inviteCode,
    loginOtherWallet,
    PopupDialog,
    PullNewPower,
    DownloadDrawer,
    // EventModal,
    searchDrawer,
    mysteriousRewards,
    GameRewardTip,
    ChargeGuide,
    FirstWithdrawGuide,
    RedeemTimeGuide,
    LuckySubsidy,
    RiskSetTip,
    GameLimitDialog,
    GrandPrizeGuide,
  },
  computed: {
    ...mapGetters(["getIsMobile", "menuIsShow"]),
    loading() {
      return this.$store.getters.getPageLoding;
    },
    popViwes() {
      return this.$store.getters.getPopBoxView;
    },
    isPopBoxShow() {
      return this.$store.getters.getPopBoxShow;
    },
    popFullscreen() {
      return this.$store.getters.getFullscreen;
    },
    getData() {
      return this.$store.getters.getData;
    },
    taken() {
      return this.$store.getters.taken;
    },
    getPacketConfig() {
      return this.$store.getters.getPacketConfig?.maintain || {};
    },
    isLogin() {
      return this.$store.getters.login;
    },
    defaultCoinCode() {
      return this.$store.state.userCoins?.defaultCoinCode || localStorage.getItem("defaultCoinCode");
    },
    getLoginConfig() {
      return this.$store.getters.getPacketConfig?.loginConfig || {};
    },
  },
  watch: {
    "$route.path": {
      handler: function (newPath, oldPath) {
        // console.log(this.$route, "=========$route=======");
        this.commonSySize();
      },
      deep: true,
      immediate: true,
    },
    "$route.meta": {
      handler: function (val) {
        // console.log(val, 'hiddenTabs')
        // 二级游戏H5界面隐藏
        if (this.getIsMobile && this.$route.name === "gameList") {
          this.showTab = false;
        } else if (val.hiddenTabs) {
          this.showTab = false;
        } else {
          this.showTab = true;
        }
        if (!this.isHome) {
          this.skeletonLoading = false;
        }
        // setTimeout(() => {
        //   this.commonSySize();
        // }, 500);
      },
      deep: true,
      immediate: true,
    },
    defaultCoinCode(n, o) {
      if (n && sessionStorage.getItem("REDEEM_CODE")) {
        this.getRedFun = debounce(() => {
          this.getRedeemCodeReward(sessionStorage.getItem("REDEEM_CODE"));
        }, 1000);
        this.getRedFun();
      }
    },
  },
  // beforeCreate() {
  //   this.getWebResource();
  // },
  async created() {
    if (this.isHome && !this.taken) {
      this.skeletonLoading = true;
    }
    this.$Bus.$on("onSkeletonLoading", (obj) => {
      this.skeletonLoading = false;
    });
    // 重新进入或刷新重置引导方式
    localStorage.setItem("drawerClosed", "");
    // 是否新设备，登陆了不算
    if (!localStorage.getItem("isNewDevice")) {
      localStorage.setItem("isNewDevice", "true");
    }
    // 您不应在页面加载时或加载后直接运行指纹。 而是使用setTimeout或requestIdleCallback将其延迟几毫秒，以确保指纹一致。
    this.browserdata = JSON.parse(localStorage.getItem("browser")) || {};
    // console.log(this.browserdata, "this.browserdata?.browser");
    if (!this.browserdata?.browser) {
      const browser = generateKey();
      // console.log(browser, "browser");
      localStorage.setItem("browser", JSON.stringify({ browser: browser.browser, murmur: browser.murmur })); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
      this.browserdata = { browser: browser.browser, murmur: browser.murmur };
    }

    // if (window.requestIdleCallback) {
    //   requestIdleCallback(() => {
    //     this.createFingerprint();
    //   });
    // } else {
    //   setTimeout(() => {
    //     this.createFingerprint();
    //   }, 500);
    // }

    this.$Bus.$on("loginSuccess", (...args) => loginSuccess(...args));
    // 注册送金奖励已到账弹窗
    this.$Bus.$on("registerRewardShow", (obj) => {
      this.$refs?.registerRewardRef?.show(obj);
    });

    await this.fromRegistor();
    sendThis(this);
    sendPopThis(this);
    sendRouterConfigThis(this);
    sendGameThis(this);
    sendUtilThis(this);
    sendPayGameThis(this);
    sendWsThis(this);
    sendBusThis(this);
    sendAuthThis(this);
    Exposure.sendExpouseThis(this);
    grandPrizeTips.sendGrandPrizeThis(this);

    const status = await this.getWebDomain();
    if (Number(status) !== 0) {
      return false;
    }
    await this.getWebResource();
    // getResource 接口错误后不执行之后的方法

    // 获取三方上报配置
    this.getAdsEventsFun();
    // 启用的功能
    this.$store.dispatch("getEnableFeatureApi");
    this.$Bus.$on("reload", () => {
      // 更新进入时间戳
      window.dateNow = Date.now();
      if (this.getIsMobile && this.menuIsShow) {
        this.setMenuBar(false);
      }
      this.isAlive = false;
      this.$nextTick(() => {
        this.isAlive = true;
      });
    });

    // 公共充值  快速发起充值
    this.$Bus.$on("commonChargeShow", (obj) => {
      if (obj?.show === false) {
        this.$refs.commonChargeRef && this.$refs.commonChargeRef.close(obj);
        return;
      }
      if (obj.commonLoading === true) {
        this.$refs.commonChargeRef.updateNewOrder(true);
      } else if (obj.commonLoading === false) {
        this.$refs.commonChargeRef.updateNewOrder(false);
      } else if (obj.isUserSecondRecharge) {
        const res = obj.res || {};
        this.$refs.commonChargeRef.userRechargeResult(
          res,
          {
            rechargeModelSid: res.rechargeModelSid || "",
            rechargeCfgMethod: res.rechargeCfgMethod || "",
          },
          obj.isUserSecondRecharge
        );
      } else {
        if (this.commonChargeLoading) return;
        this.commonChargeLoading = true;
        this.$refs.commonChargeRef.commonChargeFun(obj);
      }
    });

    const urlHref = window.location.href;
    // 拉新助力分享过来的
    if (urlHref.includes("reward_share")) {
      this.$eventPost("invite_website_open");
    }
    // 创房邀请链接过来的 不再执行后面的弹窗等逻辑
    if (urlHref.includes("game_id") && urlHref.includes("share_type")) {
      const urlParams = getUrlkey() || {};
      urlParams.time = Math.floor(Date.now() / 1000);
      localStorage.setItem("creatRoomParams", JSON.stringify(urlParams));
      const roomTitle =
        urlParams.share_type === "2"
          ? this.$t("Datalang.newly_friend_invitation")
          : this.$t("Datalang.home_share_prize");
      this.$isPopShow({
        show: true,
        views: "createRoomModal",
        data: {
          width: this.$px2rem(450),
          title: roomTitle,
          data: urlParams,
        },
      });
      if (this.isLogin) {
        this.$store.dispatch("getUserInfo");
      }
      return;
    }

    // 60scountDown
    this.redTime60();

    // 拼多多拉新活动bus
    this.$Bus.$on("showPullNewModal", (opt) => {
      this.showPullNewModal(opt);
    });
    // 兑换码弹窗结果
    this.$Bus.$on("taskSuccess", (data) => {
      console.log("taskSuccess", data);
      this.taskSuccess = {
        bonusAmount: data?.bonusAmount,
        accuracy: data?.accuracy,
        coinCode: data?.coinCode,
      };
      this.$refs.redeemDialogRef?.init(true);
    });
    // h5提现限制引导下载弹窗
    this.$Bus.$on("showH5DownloadGuide", (opt) => {
      this.showH5DownloadDrawer(opt);
    });
    // vip升级提示公告弹窗
    this.$Bus.$on("showVipTipModal", (opt) => {
      this.showVipTip(opt);
    });
    if (this.taken) {
      if (sessionStorage.getItem("REDEEM_CODE")) {
        this.getRedFun = debounce(() => {
          this.getRedeemCodeReward(sessionStorage.getItem("REDEEM_CODE"));
        }, 1000);
        this.getRedFun();
      }
      this.$store.dispatch("getUserInfo");
      const tiapzhuantype = window.location.pathname;
      // ["other", "payGame", "games"]; // 处理回调接口
      if (
        !(tiapzhuantype.split("/other")[1] || tiapzhuantype.split("/payGame")[1] || tiapzhuantype.split("/games")[1])
      ) {
        const { code, data } = await killPlayerUser({});
        // console.log(data, "app");
        if (code === 0) {
          const opt = data || {};
          if (data.gameGroupSid !== "0") {
            removeLocalStorage("currentGameStatus");
            payGameFun({ ...opt, KillOffType: true });
          }
        }
      }
      // this.$store.dispatch("activityfirstWithdrawalInfo");
    }

    if (!this.getIsMobile && !isGame()) {
      this.setMenuBar(true);
    }

    // this.$Bus.$on("loginSuccess", (...args) => loginSuccess(...args));

    this.$Bus.$on("updateBindPhoneDialogVisible", (val) => {
      this.bindPhoneDialogVisible = val;
    });

    // ws推送打码排行榜
    this.$Bus.$on("rewardShow", (obj) => {
      if (obj.type === "recharge") {
        this.$refs?.RankRewardRef?.show(obj);
      } else {
        if (document.querySelector(".rankRewardDialog1")) {
          if (obj.type === "task") {
            this.$refs?.RankRewardRef1?.show(obj);
          } else {
            this.$refs?.RankRewardRef1?.show({ ...obj, needPush: true });
          }
        } else {
          if (obj.type === "task") return;
          this.$refs?.RankRewardRef1?.show(obj);
        }
      }
      this.$refs.commonChargeRef && this.$refs.commonChargeRef.close({ show: false });
      this.$Bus.$emit("showCharge", { show: false });
    });
    // 关闭弹窗
    this.$Bus.$on("rewardTipsclose", (obj) => {
      // console.log(3333333333333);
      this.$refs?.RankRewardRef?.close();
      this.$refs?.RankRewardRef1?.close();
    });

    // 推送免费次数、VIP转盘、转盘
    this.$Bus.$on("rewardTipsShow", (obj) => {
      console.log(3333333333333);
      this.$refs?.RewardTipsRef?.show(obj);
    });

    // 错误码提示显示
    this.$Bus.$on("codeTipsShow", (obj) => {
      this.$refs?.codeTipsRef?.show(obj);
    });
    // 领奖限制显示
    this.$Bus.$on("rewardLimiteShow", (obj) => {
      this.$refs?.rewardLimiteRef?.show(obj);
    });
    // 退出游戏奖励提示
    this.$Bus.$on("gameRewardTip", (obj) => {
      this.$refs.GameRewardTipRef.show(obj);
    });
    // 首充、复充引导
    this.$Bus.$on("chargeGuide", (obj) => {
      this.$refs.ChargeGuideRef.show(obj);
    });
    // 首提引导
    this.$Bus.$on("firstWithdrawGuide", (obj) => {
      this.$refs.FirstWithdrawGuideRef.show(obj);
    });
    // 定时红包引导
    this.$Bus.$on("redeemTimeGuide", (obj) => {
      this.$refs.RedeemTimeGuideRef.show(obj);
    });
    // 游戏破产引导
    this.$Bus.$on("luckySubsidyGuide", async ({ expireTime, isLocal, items, bankruptGuideType }) => {
      if (isLocal) {
        this.$refs.LuckySubsidyRef.show({ list: items, expireTime, isLocal, bankruptGuideType });
      } else {
        // 获取破产配置
        const { code, data } = await getBankruptConfig({});
        if (code === 0) {
          if (data.rowStatus === "ROW_STATUS_ENABLE" && data.items && data.items.length) {
            const path = this.$route.path;
            // 在游戏内  才弹出破产引导
            if (path.includes("/other") || path.includes("/games") || path.includes("/payGame")) {
              const obj = data.items.find((it) => it.guideType === "BANKRUPT_GUIDE_TYPE_RECHARGE_GIFT");
              const list = data.items.filter((it) => it.guideType !== "BANKRUPT_GUIDE_TYPE_RECHARGE_GIFT");
              // 如果有充值礼包，弹礼包
              if (obj && obj.rechargeGiftId && obj.rechargeGiftId !== "0") {
                this.$isPopShow({
                  show: true,
                  views: "chargeEnvelope",
                  fullscreen: false,
                  data: {
                    sid: obj.rechargeGiftId,
                    SubGiftpack: "Bankruptcy",
                    title: "",
                    width: "360px",
                    bankruptData: {
                      expireTime,
                      isLocal: true,
                      items: list,
                      bankruptGuideType: 0,
                    },
                  },
                });
              } else {
                // 如果没有充值礼包，弹幸运补贴
                if (list.length) {
                  this.$refs.LuckySubsidyRef.show({ list, expireTime });
                }
              }
            }
          }
        }
      }
    });
    // 风险政策、风险偏好设置、风险提示
    this.$Bus.$on("riskSetTip", (obj) => {
      this.$refs.RiskSetTipRef.show(obj);
    });
    // 大奖注册充值引导
    this.$Bus.$on("grandPrizeGuide", (obj) => {
      this.$refs.GrandPrizeGuideRef.show(obj);
    });
    // 快速登录
    this.$Bus.$on("quickLoginJump", () => {
      this.quickLogin(this.$store.getters.getPacketConfig, true);
    });
    window.sendMessageToWeb = function (e) {
      // console.log("0819-sendMessageToWeb执行", typeof e === "object", e);
      if (e && typeof e === "object") {
        if (e.key === "native_init" && e.value) {
          let obj1 = {};
          try {
            obj1 = JSON.parse(e.value);
          } catch (error) {
            obj1 = e.value;
          }
          if (obj1.fcm_register_token) {
            window.localStorage.setItem("fcmRegisterToken", JSON.stringify(obj1.fcm_register_token));
            if (this.taken) {
              firebaseSave({ token: obj1.fcm_register_token }).then((res) => {
                if (res.code === 0) {
                  removeLocalStorage("fcmRegisterToken");
                }
              });
            }
          }
        } else if (e.key === "native_notice" && e.value) {
          let obj2 = {};
          try {
            obj2 = JSON.parse(e.value);
          } catch (error) {
            obj2 = e.value;
          }
          if (obj2.notice_launch && obj2.msg_sid) {
            const SubOffline = obj2.notice_launch === "pwa" ? "CLICK_EVENT_PWA" : "CLICK_EVENT_FIREBASE";
            clickEvent({ eventType: SubOffline, msgSid: obj2.msg_sid });
          }
        }
      }
    };

    // 缓存个人中心功能配置
    // this.cachePersonalCenterTemplate();
  },
  mounted() {
    const timeoutLog = debounce((msg, source, line, column, err) => {
      eventPost("timeout_log_web", { type: "onerror", msg, source, line, column, err });
    }, 1000);

    const timeoutLogUnhandled = debounce((message, url, stack) => {
      eventPost("timeout_log_web", { type: "unhandledrejection", msg: message, messageErrorUrl: url, stack });
    }, 1000);
    window.onerror = function (msg, source, line, column, err) {
      // console.log(msg, source, line, column, err, "msg, source, line, column, err");
      const errormsg = [
        "Request failed with status code 401",
        "Network Error",
        "Script error.",
        "Request aborted",
        "Rejected",
        "timeout of 30000ms exceeded",
        "SyntaxError: Unexpected token '.'",
        "Failed to fetch",
      ];
      const isRedirected = typeof msg === "string" && msg.includes("Redirected when going from");
      // console.log("window.onerror----", msg);
      if (typeof msg === "string" && msg.includes("timeout of 30000ms exceeded")) {
        timeoutLog(msg, source, line, column, err);
        // eventPost("timeout_log", { type: "onerror", msg, source, line, column, err });
      } else if (!errormsg.includes(msg) && msg && !isRedirected) {
        eventPost("err_log", { msg, source, line, column, err });
      }
      return true;
    };
    window.addEventListener("unhandledrejection", (event) => {
      // console.log(event, "aaaaaaaaaaaaaaaaaaaaaa");
      // let message = event && event.reason && event.reason.message;
      const message = event?.reason?.message || "";
      const url = event?.reason?.config?.url || "";
      const stack = event?.reason?.stack || "";
      // const config_data = event?.reason?.config?.data || "";

      // const headers = JSON.stringify({ headers: event?.reason }) || "";
      // console.log(headers, "headers ");
      // console.log('监听unhandledrejection', event, message)
      const isRedirected = typeof message === "string" && message.includes("Redirected when going from");
      if (message && message.includes("timeout of 30000ms exceeded")) {
        timeoutLogUnhandled(message, url, stack); // 调用防抖函数
        // eventPost("timeout_log", { type: "unhandledrejection", msg: message, messageErrorUrl: url, stack });
      } else if (!this.errormsg.includes(message) && message && !/^Loading chunk/.test(message) && !isRedirected) {
        // console.log(url, message, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        eventPost("err_log", {
          msg: message,
          messageErrorUrl: url,
          // config_data: config_data,
          // headers: headers,
          stack: stack,
        });
      }
    });
    if (this.show === 1050053) {
      return;
    }
    window.addEventListener("load", this.recordFirstScreenLoadTime);
    // document.body.removeChild(document.getElementById("Loading"));
    // this.commonSySize();
    window.addEventListener("resize", this.commonSySize);
    // this.intAdjustSDK();
    const timer = setTimeout(() => {
      this.intFbSDK();
      clearTimeout(timer);
    }, 2000);
    // 创建媒体查询
    var mediaQuery = window.matchMedia("(orientation: landscape)");
    // 监听媒体查询变化
    mediaQuery.addListener(this.checkOrientation);
    // 初始加载时检查设备方向
    this.checkOrientation(mediaQuery);
    // setTimeout(() => {
    //   this.$eventPost("click_icon");
    // }, 1000);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    if (this.getIsMobile && /Instagram/i.test(navigator.userAgent)) {
      this.$nextTick(() => {
        this.showInstagramTip = true;
      });
    }
  },
  methods: {
    ...mapActions(["setMenuBar"]),
    cachePersonalCenterTemplate() {
      getPersonalCenterTemplate({}).then((res) => {
        if (res.code === 0) {
          setCacheData("personalCenterTemplate", res.data);
        }
      });
    },
    handleToVip() {
      this.closeVipTip();
      const path = this.getIsMobile ? "/hEvents" : "/events";
      this.$router.push({
        path: path,
        query: {
          tab: 1,
          t: Date.now(),
        },
      });
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        // 如果是TG APP 并且不需要隐藏反馈
        if (this.isTgApp && !this.$route.meta.hideTGBack) {
          TelegramUtil.showBackButton();
        }
      }
    },
    bindPhoneConfirm() {
      const path = this.getIsMobile ? "/user/hAccountInfo" : "/user";
      sessionStorage.setItem("showEditModal", "mobile");
      this.$router.push(path);
      this.bindPhoneDialogVisible = false;
    },
    redTime60() {
      const timing = this.$store.getters.getPacketConfig?.appConfig?.timing || null;
      const timing_style = this.$store.getters.getPacketConfig?.appConfig?.timingStyle || null;
      // timing = ['2:11']
      // this.$refs.redeemTimeCountdownRef?.show();
      // return;
      if (!this.taken) {
        return;
      }
      if (timing) {
        this.redTimer = setInterval(() => {
          const inTime = this.isOneMinuteAway(timing);
          if (inTime && !isGame()) {
            if (parseInt(timing_style) === 2) {
              // console.log("定时红包", timing_style);
              this.$isPopShow({
                show: true,
                views: "redeemTime",
                fullscreen: false,
                data: {
                  title: this.$t("Datalang.Scheduled_Red_Packets"),
                },
              });
              this.$emit("redeemTimeinit", timing_style);
            } else {
              this.$refs.redeemTimeCountdownRef?.show();
            }
          }
        }, 500);
      }
    },
    isOneMinuteAway(times) {
      // 获取当前时间的小时和分钟，并转换为已过去的分钟数
      const now = new Date(getAnyZoneTimeStamp());
      const currentSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

      // 遍历数组中的时间，并判断是否距离当前时间只差 4 秒
      return times.some((timeStr) => {
        const [hour, minute] = timeStr.split(":").map(Number);
        const targetSeconds = Number(hour) * 3600 + Number(minute) * 60;
        // 判断是否距离目标时间差 4 秒
        const offset = targetSeconds - currentSeconds;
        // console.log("offset=>", offset, timeStr);

        const flag = offset <= 4 && offset > 0 && !this.isShowTime[timeStr];

        if (flag) {
          this.isShowTime[timeStr] = true;
        }
        return flag;
      });
    },
    globalClickHandle(event) {
      // console.log("全局click123");
      this.$Bus.$emit("globalClickHandle", event);
    },

    async fromRegistor() {
      const urlParams = new URLSearchParams(window.location.search);
      const param1 = urlParams.get("registor_promotion_token");

      // console.log("fromRegistor", urlParams, param1);

      if (param1) {
        // 处理参数...
        const { code, data } = await getTokenByPromotion({
          registor_promotion_token: param1,
        });
        console.log("getTokenByPromotion", data);
        if (code === 0 && data?.token) {
          this.$store.commit("setTaken", {
            accessToken: data.token,
            refreshToken: data.refreshToken,
          });
          this.$store.commit("setIsLogin", true);
        }
      }
    },
    async getWebDomain() {
      // const { code, data } = await getServiceDomain({});
      // 通过邀请码拿渠道信息
      let uid = window.localStorage.getItem("inviteCode");
      // uid没有传0
      if (!uid) {
        uid = "0";
      } else {
        try {
          uid = JSON.parse(uid);
        } catch (error) {
          uid = "0";
        }
        const uid1 = Number(uid);
        if (!isNaN(uid1)) {
          // uid是数字传0, 代理生成的邀请码是英文，用户自发分享的是数字算自然流量
          uid = "0";
        }
      }
      try {
        const { code, data, msg } = await getConf({ client: "web", inviteCode: uid });
        if (code !== 0) {
          await setLocaleArr(data?.resp?.packetLanguages);
          await setLocale();
          const dom = document.getElementById("viewsLoading");
          if (dom) {
            document.body.removeChild(dom);
          }
        }
        if (code === 1050053 || code === 1050052) {
          // 系统维护， ip 访问受限
          if (code === 1050053) {
            this.dataip = { ip: msg || "" };
          }
          return code;
        }
        if (code === 0) {
          const _data = {
            ...data.resp,
            tpl: {
              ...data.tpl,
              getResourcePc: data.tpl?.getResource?.replace(/_\d_/, "_1_"),
              getResourceH5: data.tpl?.getResource?.replace(/_\d_/, "_2_"),
            },
            activityInfo: data?.activityInfo || null,
            personalCenterShowType: data?.personalCenterShowType,
          };
          setPacketConfig({
            packetInfo: {
              baseInfo: {
                languages: _data?.packetLanguages || [],
              },
              config: {
                defaultLanguage: _data?.packetDefaultLanguage,
              },
            },
          });
          await setLocaleArr(data?.resp?.packetLanguages);
          await setLocale();
          try {
            const domain = getLocalStorage("packetDomain");
            if (domain) {
              if (domain?.templateLastUpdateTime !== _data.templateLastUpdateTime) {
                // 模版有更新，清除缓存
                await clearAllDB();
              }
            }
          } catch (error) {
            console.log(error);
          }

          store.commit("setPacketDomain", _data);
          saveDataToIndexedDB("domain", _data);

          try {
            const redeem_code = sessionStorage.getItem("REDEEM_CODE") || "";
            const web_url = window.location.hostname;
            const device_id = getDeviceInfo().deviceId;
            if (!this.taken) {
              const channelId = data?.channelId || "0";
              if (channelId !== "0") {
                window.localStorage.setItem("channelId", channelId);
              }
              this.$eventPost("click_icon", { redeem_code, web_url, device_id });
            } else {
              this.$eventPost("click_icon", { redeem_code, web_url, device_id });
            }
          } catch (error) {}
        }
        this.show = code;
        return code;
      } catch (err) {
        await setLocaleArr();
        await setLocale();
      }
    },
    async getAdsEventsFun() {
      try {
        const opt = {};
        const promoteSid = localStorage.getItem("promoteSid");
        if (promoteSid) {
          opt.promoteSid = promoteSid;
        }
        const { code, data } = await getAdsEvents(opt);
        if (code === 0) {
          const adsEventConfig = data.adsEventConfig || [];
          store.commit("setAdsEventConfig", adsEventConfig);
          await adsEventsInit(adsEventConfig);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async quickLoginFun(data) {
      try {
        console.log("test-222-id");
        await store.dispatch("thirdLoginAction", { data });
      } catch (error) {
        console.log(error);
      }
    },
    async quickLogin(data, isClick) {
      // isClick 是否是点击快速登录
      let params = window.localStorage.getItem("localInitQuery");
      const quickLoginFlag = window.localStorage.getItem("quickLoginFlag");
      const PASSWORD_MAP = window.localStorage.getItem("PASSWORD_MAP");
      if (params) {
        params = JSON.parse(params);
      }
      // 小飞机内打开自动登陆-带的参数跟app马甲包参数一样, 开了一键登陆首次进入自动登陆注册
      console.log("test-111-params", params, params?.ft === "tg");
      let cond = "";
      if (isClick) {
        cond = data.loginConfig?.thirdLoginList?.find((i) => i.loginType === "quick_login") && !this.taken;
      } else {
        cond =
          !quickLoginFlag &&
          data.loginConfig?.thirdLoginList?.find((i) => i.loginType === "quick_login") &&
          !this.taken &&
          !PASSWORD_MAP &&
          this.getLoginConfig.autoRegisterSwitch === 1; // 自动开关开启
      }
      if (params?.ft === "tg" || cond) {
        // store.commit("setTaken", "");
        // store.commit("setIsLogin", false);
        let datalist = {
          inviteCode: getLocalStorage("inviteCode") || "",
          coinCode: data.appConfig?.coinCode || store.getters.getPacketConfig?.appConfig?.coinCode,
        };
        if (params?.ft === "tg") {
          // 获取用户信息 Telegram WebApp
          const tg = window?.Telegram?.WebApp;
          const tgUserInfo = tg.initDataUnsafe?.user;
          const paramsObj = {
            create_by: "tg",
            id: params.device_id || tgUserInfo?.id,
            first_name: params.first_name || tgUserInfo?.first_name,
            last_name: params.last_name || tgUserInfo?.last_name,
            photo_url: params.photo_url || tgUserInfo?.photo_url,
          };
          const nickname = paramsObj.first_name + paramsObj.last_name;
          let paramsStr = "";
          Object.keys(paramsObj).map((key, index) => {
            const str = index === 0 ? "" : "&";
            paramsStr += paramsObj[key] ? str + key + "=" + paramsObj[key] : "";
          });
          datalist = {
            ...datalist,
            params: paramsStr,
            loginType: "THIRD_LOGIN_TYPE_TELEGRAM",
            loginTypeStr: "telegram",
          };
          if (nickname) {
            datalist.nickname = nickname;
          }
          if (paramsObj.id) {
            const initQuery = getLocalStorage("initQuery") || {};
            setLocalStorage("initQuery", { ...initQuery, device_id: String(paramsObj.id) });
            setLocalStorage("localInitQuery", { ...params, device_id: String(paramsObj.id) });
          }
        } else {
          datalist = {
            ...datalist,
            params: JSON.stringify({ ...getDeviceInfo() }),
            loginType: "THIRD_LOGIN_TYPE_QUICK_LOGIN",
            loginTypeStr: "quick_login",
          };
        }
        if (this.isHome && !this.taken && !isClick) {
          this.skeletonLoading = false;
        }
        await this.quickLoginFun(datalist);
      }
    },
    async getWebResource() {
      // 当前美东时间戳
      const ts = Math.floor(getAnyZoneTimeStamp() / 1000);
      // 通过邀请码拿渠道信息
      let uid = window.localStorage.getItem("inviteCode");
      // uid没有传0
      if (!uid) {
        uid = "0";
      } else {
        try {
          uid = JSON.parse(uid);
        } catch (error) {
          uid = "0";
        }
        const uid1 = Number(uid);
        if (!isNaN(uid1)) {
          // uid是数字传0, 代理生成的邀请码是英文，用户自发分享的是数字算自然流量
          uid = "0";
        }
      }
      const { code, data: resourceData, msg } = await getResource({ ts: String(ts), inviteCode: uid, client: "web" });

      // 处理缓存
      cacheManage(resourceData);

      const data = resourceData.resource;
      console.log(resourceData, "resource=>");
      setPacketConfig(data);
      // await setLocaleArr(data?.packetInfo?.baseInfo?.languages);
      // setLocale();

      const dom = document.getElementById("viewsLoading");
      if (dom) {
        document.body.removeChild(dom);
      }

      if (code === 1050053 || code === 1050052) {
        // 系统维护， ip 访问受限
        //
        if (code === 1050053) {
          this.dataip = { ip: msg };
        }
        this.show = code;
        return code;
      }
      if (code === 0) {
        store.commit("setPacketConfig", data);
        this.$store.commit("setMaintain", data.maintain);
        if (window.Telegram && window.Telegram.WebApp) {
          try {
            window.Telegram.WebApp.ready();
            window.Telegram.WebApp.expand();
            window.Telegram.WebApp.enableClosingConfirmation();
            window.Telegram.WebApp.requestFullscreen();
            window.Telegram.WebApp.disableVerticalSwipes();
            if (["android", "ios"].includes(window.Telegram.WebApp.platform)) {
              // Telegram.WebApp.expand();
              // Telegram.WebApp.requestFullscreen();
            }
          } catch (error) {
            console.log(error);
          }
        }
        await this.quickLogin(data);
        this.show = code;

        const redeem_code = sessionStorage.getItem("REDEEM_CODE") || "";
        const web_url = window.location.hostname;
        const device_id = getDeviceInfo().deviceId;
        if (!this.taken) {
          const channelId = data?.channelId || "0";
          if (channelId !== "0") {
            window.localStorage.setItem("channelId", channelId);
          }
          this.$eventPost("click_icon", { redeem_code, web_url, device_id });
        } else {
          this.$eventPost("click_icon", { redeem_code, web_url, device_id });
        }

        if (data.appConfig?.firebasePublicKey) {
          // 注册推送通知
          register(data.appConfig?.firebasePublicKey);
        }
        if (data.maintain && data.maintain["0"]) {
          this.hasMaintain = true;
        } else {
          this.hasMaintain = false;
        }
        thirdLoginInit(data);
        eventsInit(data);
        data.coinInfo = {};
        if (data.coinList && data.coinList.length > 0) {
          data.coinList.map((v) => {
            data.coinInfo[v.coinCode] = { ...v };
          });
        }

        // this.$store.commit("setMaintain", data.maintain);
        return code;
      }
    },
    isMobile() {
      // match方法可在字符串内检索指定的值，
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
    ...mapMutations(["setFullscreen"]),
    checkOrientation(mediaQuery) {
      setTimeout(() => {
        const isMobile = document.body?.offsetWidth < 768;
        this.$store.commit("setIsMobile", isMobile);
        if (mediaQuery.matches) {
          // 设备处于横向（横屏）状态
          console.log("横向", isMobile, document.body?.offsetWidth);
          this.setFullscreen(isMobile);
          redirectUserPage(isMobile ? "h5" : "pc");
        } else {
          // 设备处于纵向（竖屏）状态
          console.log("纵向", isMobile, document.body?.offsetWidth);
          this.setFullscreen(isMobile);
          redirectUserPage(isMobile ? "h5" : "pc");
        }
      }, 100);
    },
    commonSySize(flag) {
      // console.log("commonSySize", flag);
      const idTag = document.body;

      if (window.innerWidth >= 768 || window.innerWidth >= window.innerHeight) {
        // 切PC或者宽度大于高度，隐藏h5二级游戏弹窗
        console.log(this.getData);
        if (this.getData?.type === "hgame") {
          this.$isPopShow({
            show: false,
            views: "hgame",
          });
        }
      }
      if (idTag?.offsetWidth < 768) {
        this.setFullscreen(true);
        this.$store.commit("setIsMobile", true);
        redirectUserPage("h5");
      } else {
        this.setFullscreen(false);
        this.$store.commit("setIsMobile", false);
        redirectUserPage("pc");
      }
      // console.log("idTag?.offsetWidth", idTag?.offsetWidth, this.getIsMobile);
    },
    browserRedirect() {
      const sUserAgent = navigator.userAgent.toLowerCase();
      const bIsIpad = sUserAgent.match(/ipad/i) === "ipad";
      const bIsIphoneOs = sUserAgent.match(/iphone os/i) === "iphone os";
      const bIsMidp = sUserAgent.match(/midp/i) === "midp";
      const bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) === "rv:1.2.3.4";
      const bIsUc = sUserAgent.match(/ucweb/i) === "ucweb";
      const bIsAndroid = sUserAgent.match(/android/i) === "android";
      const bIsCE = sUserAgent.match(/windows ce/i) === "windows ce";
      const bIsWM = sUserAgent.match(/windows mobile/i) === "windows mobile";
      if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        // 跳转移动端页面
        this.$store.commit("setIsMobile", true);
      } else {
        // 跳转pc端页面
        this.$store.commit("setIsMobile", false);
        // console.log("跳转pc端页面");
      }
    },
    async getRedeemCodeReward(redeemCode) {
      // 请求领取红包接口
      if (!redeemCode) return false;
      const { code, data } = await redRedeemCodeReceive({ redeemCode: redeemCode });
      if (code === 0) {
        const rewardType = data?.rewardType || "ACTIVITY_REWARD_TYPE_MONEY"; // 奖励类型 默认金额奖励
        this.$router.push("/home");
        window.sessionStorage.removeItem("REDEEM_CODE");
        if (rewardType === "ACTIVITY_REWARD_TYPE_MONEY") {
          this.taskSuccess = {
            bonusAmount: data?.bonusAmount,
            accuracy: data?.accuracy,
            coinCode: data?.coinCode,
          };
          this.$refs.redeemDialogRef?.init(true);
        } else {
          setTimeout(() => {
            this.$refs?.RewardTipsRef?.show(data);
          }, 1000);
        }
      } else {
        this.$router.push("/home");
        window.sessionStorage.removeItem("REDEEM_CODE");
      }
    },
    // 处理是否显示拉新助力弹窗
    showPullNewModal(data) {
      //   console.log("PullNewModal", data);
      this.pullNewInfo = data.pullNewInfo || {};
      // this.pullNewInfo = { ...data.pullNewInfo, isStart: 4 };
      // this.pullNewInfo = { ...data.pullNewInfo, rewardStyle: 1 };
      this.isStart = this.pullNewInfo.isStart;
      this.showPullNewDialog = data.show;
    },
    closePullNewDialog(flag) {
      console.log(this.pullNewInfo.isPop, "isPop");
      if (!flag && this.pullNewInfo.isPop) this.$popConfig.winConfigNext();
      this.showPullNewDialog = false;

      this.$Bus.$emit("updateBonusList");
    },
    changePullNewDialog(isStart) {
      this.isStart = isStart;
    },
    // h5提现限制引导下载弹窗
    showH5DownloadDrawer(data) {
      console.log("h5DownloadDrawerInfo", data);

      this.h5DownloadDrawerInfo = data;
      this.showDownloadDrawer = true;
    },
    closeH5DownloadDrawer() {
      this.showDownloadDrawer = false;
    },
    // vip升级提示公告弹窗
    showVipTip(data) {
      console.log("vipTipList", data);
      this.vipTipList = data;
      this.showEventModal = true;
    },
    // 关闭弹窗
    closeVipTip(flag) {
      this.showEventModal = false;
    },
    changeLoading(val) {
      this.commonChargeLoading = val;
    },
    recordFirstScreenLoadTime() {
      // 获取首屏加载时间
      setTimeout(() => {
        // 上传心跳，2s一次
        Exposure.sendHeartBeat();
        // 大奖提示 后台开关开启 并且未充值
        // const userInfo = this.$store.getters.user || {};
        // if (this.getLoginConfig.popRegisterRechargeGuide !== 2 && !userInfo.isRecharge) {
        //   grandPrizeTips.initGrandPrizeList();
        // }
        // 消息通知上报
        const noticeLaunch = getLocalStorage("noticeLaunch") || {};
        if (noticeLaunch.notice_launch) {
          const SubOffline = noticeLaunch.notice_launch === "pwa" ? "CLICK_EVENT_PWA" : "CLICK_EVENT_FIREBASE";
          // this.$eventPost("offline_msg_click", { SubOffline, msg_sid: noticeLaunch.msg_sid });
          clickEvent({ eventType: SubOffline, msgSid: noticeLaunch.msg_sid });
          removeLocalStorage("noticeLaunch");
        }
        // 保存用户Firebase信息(从马甲包里面传过来的设备token)
        if (this.taken) {
          const fcmRegisterToken = getLocalStorage("fcmRegisterToken");
          if (fcmRegisterToken) {
            firebaseSave({ token: fcmRegisterToken }).then((res) => {
              if (res?.code === 0) {
                removeLocalStorage("fcmRegisterToken");
              }
            });
          }
        }
        const performanceEntries = performance.getEntriesByType("navigation");
        if (performanceEntries.length > 0) {
          // console.log(
          //   "=============app时间=============:",
          //   performanceEntries[0],
          //   performanceEntries[0].loadEventStart,
          //   performanceEntries[0].loadEventEnd,
          //   performanceEntries[0].domComplete,
          // );
          if (this.show === 1050053 || this.show === 1050052) return;
          const loadTime = performanceEntries[0].loadEventEnd || performanceEntries[0].domComplete; // 加载结束时间loadEventEnd
          this.firstScreenLoadTime = Math.floor(loadTime);
          console.log("=============app加载完成时间=============:", this.firstScreenLoadTime);
          // console.log("=============app now=============:", Date.now() - window.dateNow);
          this.$eventPost("web_resource_success", { time: this.firstScreenLoadTime });
        }
        try {
          const app = document.querySelector("#appshow"); // Vue/React 根节点
          if (app && app.innerText.trim().length === 0 && app.children.length === 0) {
            this.$eventPost("white_screen", { time: this.firstScreenLoadTime });
            // console.log('"white_screen", "5s 内未渲染内容"');
          }
        } catch (error) {
          console.log(error);
        }
      }, 5000);
    },
  },
  beforeDestroy() {
    this.redTimer && clearInterval(this.redTimer);
    Exposure.clearExposureTimer();
    // grandPrizeTips.clearGrandPrizeTimer();
    window.removeEventListener("resize", this.commonSySize);
    window.removeEventListener("unhandledrejection", (event) => {});
    window.removeEventListener("load", this.recordFirstScreenLoadTime);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
};
</script>

<style lang="scss">
@import url("~@/assets/font/font.css");
#skeletonLoading_logo {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--background-100);
  .skeletonLoading {
    top: 50%;
    left: 50%;
    position: fixed;
    -webkit-transform: translateY(-50%) translateX(-50%);
    transform: translateY(-50%) translateX(-50%);
    z-index: 100;
  }
}
.bindPhone-dialog {
  padding: 15px;
  .bottom-wrap2 {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 0px;
  }
  .text-content {
    font-size: 14px;
    color: var(--font-color-900);
    min-height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .text {
      word-break: break-word;
      width: 100%;
      text-align: center;
      line-height: 22px;
    }
    .text1 {
      color: var(--font-color-100);
    }
    .icon {
      width: 45px;
      margin-bottom: 10px;
    }
  }
  .close {
    cursor: pointer;
    width: 50%;
    max-width: 350px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    @include buttonPrimary;
    color: var(--font-color-1300) !important;
  }
}
.game-name-bg {
  position: absolute;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  bottom: 0;
  background-image: url("~@/assets/game/icon_sport.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0px 1px 2px 0px #666666;
  box-sizing: border-box;
  .game-text {
    text-align: center;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    color: var(--font-color-200);
    overflow: hidden; /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    box-sizing: border-box;
    padding: 0 5px;
    line-height: 24px;
    // min-height: 30px;
  }
}
@media (max-width: 768px) {
  .game-name-bg {
    // margin-top: 10px;
    font-size: 14px;
    height: 30px;
    .game-text {
      padding-bottom: 10px !important;
      font-size: 13px;
      line-height: 13px;
      max-height: 32px;
    }
  }
}
* {
  // word-break: break-word;
  // hyphens: auto;
  word-break: normal;
}
html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0 auto;
  background: var(--background-100);
  // font-family: SofiaPro, "Roboto", sans-serif !important;
  font-family: buer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  // position: fixed;
  color: var(--font-color-100);
  /* mobile viewport bug fix */
  height: -webkit-fill-available;
  background-attachment: fixed;
}

body,
html {
  -webkit-overflow-scrolling: touch;
  user-select: none;
  min-height: -webkit-fill-available;
}

body {
  width: 100%;
  height: 100%;
  font-size: 16px;
  // overflow: hidden;
  // overflow-y: auto;
}

/* 手机端去掉点击div、button、el-button时的高亮色 */
@media (max-width: 768px) {
  div,
  button {
    -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
    -webkit-appearance: none;
  }
}

.transition {
  transition: 0.5s;
  -ms-transition: 0.5s;
  -moz-transition: 0.5s;
  -webkit-transition: 0.5s;
}

#app {
  width: 100%;
  height: 100%;
  // position: fixed;
  //height: -webkit-fill-available;
  // overflow: hidden;
}

.el-select .el-input .el-input__suffix .el-icon-arrow-up {
  transform: rotate(180deg) \0;
}

.el-message .el-message__content {
  display: inline-block\0;
}

.el-cascader-menu__list .el-cascader-node .el-cascader-node__postfix,
.el-cascader-menu__list .is-active .el-cascader-node__prefix {
  top: 10px\0;
}

demonstration,
.el-date-editor--datetimerange {
  display: inline-block !important;

  vertical-align: middle;

  line-height: 24px;
}

.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}

.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}

a:focus,
input:focus,
p:focus,
img,
span,
div:focus {
  outline: none;
}

// aa
div#driver-popover-item {
  max-width: 250px !important;
  position: fixed;

  div.driver-popover-title {
    display: none; // 隐藏标题
  }

  div.driver-popover-footer {
    .driver-btn-group {
      button.driver-prev-btn {
        display: none !important; // 隐藏上一步按钮
      }
    }
  }
}

#driver-popover-item {
  background: var(--popup-100) !important;

  .driver-popover-description {
    min-height: 42px;
    color: var(--font-color-100) !important;
  }

  .left {
    border-color: transparent var(--popup-100) transparent transparent !important;
  }

  .top {
    border-color: transparent transparent var(--popup-100) !important;
  }

  .right {
    border-color: transparent transparent transparent var(--popup-100) !important;
  }

  .driver-popover-footer {
    button {
      background: var(--button-600) !important;
      color: var(--font-color-200) !important;
      border: none !important;
      text-shadow: none !important;
    }
  }
}

.icon-arrow-common {
  width: 28px !important;
  height: 28px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--button-1200);
  color: var(--font-color-200);
  border-radius: var(--radius-200);
  transition: background ease 0.3s;
  &:hover {
    background: var(--button-1201);
  }
  &.disabled {
    color: var(--font-color-600);
    background: var(--background-700);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.child-view {
  height: 100%;
  transition: all 0.45s cubic-bezier(0.55, 0, 0.1, 1);
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
@media (max-width: 500px) {
  .el-message-box {
    width: 90%;
  }
}

.h5-menu-bar {
  position: fixed;
  left: 0;
  // bottom: 55px;
  bottom: 0;
  top: 0;
  width: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  &.memu-right {
    .menu-box {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  &.menuopen {
    width: 100vw;
    .menu-box {
      width: 100vw;
      @media (max-width: 768px) {
        // width: 180px;
      }
    }
  }
  .menu-box {
    transition: width 0.2s;
    background-color: var(-background-300);
    width: 0;
    height: 100%;
  }
}
.h5-menu-bar {
  background: none;
  padding: 0;
  width: 0;
  .nav-menu-wrap {
    .nav-menu-list {
      box-sizing: border-box;
      // padding: 0 10px;
      // padding-top: 10px;
    }
  }
}
.h5-menu-bar {
  &.menuopen {
    padding: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100vw;
  }
}
.p-hot-box .item-img {
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    // box-shadow: inset 0 0 27px 3px rgba(0, 0, 0, 0.65);
    z-index: 1;
  }
}
.el-dialog__wrapper.topAuto {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-dialog {
    margin: auto !important;
  }
}
/* 全局样式文件中添加适配TGAPP 全屏 */
.el-message {
  top: calc(20px + var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px)) !important;
  /* 如果需要额外的间距可以加上 margin-top */
  // margin-top: 10px;
}

/*滚动条的滑轨背景颜色,可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/
::-webkit-scrollbar-track {
  background: var(--border-color-100);
}

/* 滑块颜色 */
::-webkit-scrollbar-thumb {
  background: var(--border-color-100);
  opacity: 0.7;
}

/*滚动条两端的按钮。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/
::-webkit-scrollbar-button {
  display: none;
}

/* 横向滚动条和纵向滚动条相交处尖角的颜色 */
::-webkit-scrollbar-corner {
  background: var(--border-color-100);
}
.el-icon-arrow-down {
  transition: transform 0.3s;
}
.is-reverse {
  transform: rotateZ(-180deg);
}
.vip-dialog {
  @media (max-width: 768px) {
    margin-top: 6vh;
  }
}
.vip-dialog .el-dialog {
  margin-top: 5vh !important;
  background: none !important;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    @media (max-width: 768px) {
      padding: 0;
    }
  }
}

.vip-container-dialog {
  position: relative;
  .vip-close {
    position: absolute;
    top: 20px;
    right: 10px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 24px;
    text-align: center;
    cursor: pointer;
  }
  .vip-content {
    position: absolute;
    top: 32%;
    left: 10%;
    right: 10%;
    color: #9c4904;
    @media (max-width: 768px) {
      // top: 50px;
      // left: 82px;
      // right: 50px;
    }
  }
  .vip-title {
    padding-bottom: 5px;
    color: #8e2804;
    font-size: 25px;
    line-height: 26px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    @media (max-width: 768px) {
      font-size: 22px;
    }
  }
  .vip-level {
    position: absolute;
    left: 18%;
    top: 17%;
    width: 27%;
    padding: 10px 0;
    text-align: center;
    font-size: 32px;
    color: #ec5106;
    /* 渐变颜色（从左到右）*/
    background: linear-gradient(90deg, #fabe08 0%, #f2fdb9 100%);

    /* 关键：把背景裁剪到文字上 */
    -webkit-background-clip: text;
    background-clip: text;

    /* 关键：把文字本身填充透明（WebKit） */
    -webkit-text-fill-color: transparent;
    padding-top: 0;
    @media (max-width: 768px) {
      // padding: 10px 0;
      // padding-top: 0;
      // font-size: 46px;
    }
  }
  .vip-bg {
    max-width: 100%;
    @media (max-width: 768px) {
      max-width: 100%;
    }
  }
  .vip-tip {
    line-height: 20px;
    letter-spacing: 0px;
    font-size: 18px;
    color: #9c4904;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 12;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 16px;
      -webkit-line-clamp: 4;
      text-align: center;
    }
  }
  .vip-btn {
    width: 116px;
    height: auto;
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    @media (max-width: 768px) {
      width: 110px;
      height: auto;
      // bottom: 60px;
    }
    .btn-txt {
      position: absolute;
      left: 0;
      top: 12%;
      font-size: 16px;
      line-height: 22px;
      color: #fefadd;
      text-align: center;
      width: 100%;
      font-weight: bold;
      @media (max-width: 768px) {
        top: 12%;
      }
    }
    .btn-img {
      width: 100%;
      height: 100%;
    }
  }
}
@media screen and (max-width: 750px) and (orientation: landscape) {
  .vip-container-dialog {
    max-width: 66vw;
    margin: 0 auto;
    .vip-content {
      top: 40px;
      left: 62px;
      right: 40px;
    }
    .vip-title {
      font-size: 14px;
    }
    .vip-level {
      font-size: 26px;
    }
    .vip-btn {
      width: 80px;
      bottom: 50px;
      .btn-txt {
        bottom: 20px;
        font-size: 12px;
      }
    }
    .vip-tip {
      font-size: 12px;
      line-height: 14px;
    }
    .vip-close {
      right: 0;
      top: 10px;
    }
  }
}
.el-message.reward-tip-message {
  top: calc(40px + var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px)) !important;
  min-width: 375px;
  // max-width: 500px;
  height: 67px;
  background: url("~@/lobby_common/assets/activity/runninglight_zh.png") no-repeat;
  background-size: 100% 100%;
  border: none;
  padding: 0;
  border-radius: 0;
  z-index: 2000 !important;
  .el-message__icon,
  .el-message__closeBtn {
    display: none;
  }
  .el-message__content {
    font-size: 14px;
    color: #fff;
    padding: 0 30px 0 60px;
    line-height: 16px;
  }
}
</style>
